export { default as JapaneseSyllabaryLines } from './JapaneseSyllabaryLines.js';
